import { inject, InjectionToken } from '@angular/core';
import { PlatformService } from '@doka/angular-core';

export const mobileRoot = 'return';
export const webRoot = 'return';

export const APP_ROOT = new InjectionToken<string>('APP_ROOT', {
  providedIn: 'root',
  factory: () => (inject(PlatformService).platform$() == 'mobile' ? mobileRoot : webRoot),
});
